<div class="modal-header">
  <h4 class="modal-title">{{ 'manageVersions.title' | translate }}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    @if (articlesByVersions()) {
      <b>{{ articleVo.articleNo }}</b>
      <table>
        <thead>
        <tr>
          <th>{{ 'manageVersions.table.header.version' | translate }}</th>
          <th>{{ 'manageVersions.table.header.3d_object_url' | translate }}</th>
        </tr>
        </thead>
        <tbody>
          @for (articleVersion of articlesByVersions(); track $index) {
              <tr (click)="selectArticleNumber(articleVersion)"
                  [class.text-primary]="currentVersion == articleVersion.version"
                  [class.selected]="articleVersion.version == selectedVersion">
                <td>{{ articleVersion.version }}</td>
                <td>
                  {{ articleVersion.representations[0]?.url.localizedValues[0].stringValue }}
                </td>
              </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
<div class="modal-footer d-flex flex-column">
  <div class="d-flex flex-row">
    <button [disabled]="articlesByVersions().length === 0" class="btn btn-delete btn-secondary mx-1" (click)="deleteLatest()">
      {{ 'manageVersions.button.delete_latest' | translate }}
    </button>
    <button [disabled]="articlesByVersions().length === 0" class="btn btn-delete btn-secondary mx-1" (click)="deleteAll()">
      {{ 'manageVersions.button.delete_all' | translate }}
    </button>
  </div>
  <div class="d-flex flex-row">
    <button class="btn btn-secondary btn-cancel mx-1" (click)="close()">
      {{'global.label.cancel' | translate}}
    </button>
    <button [disabled]="selectedVersion >= articlesByVersions().length" class="btn btn-primary mx-1" (click)="open()">
      {{ 'manageVersions.button.open' | translate }}
    </button>
  </div>
</div>
